import { ClientTrailer, TrailerOwnershipType, TrailerStatus } from '@numeo/types'
import axios from 'axios'

const API_BASE_URL = '/trailers'

export interface TrailerFilterParams {
    status?: TrailerStatus
    ownershipType?: TrailerOwnershipType
}

export const getTrailers = async (filters?: TrailerFilterParams): Promise<ClientTrailer[]> => {
    // Build query parameters
    const queryParams = new URLSearchParams()
    if (filters?.status) queryParams.append('status', filters.status)
    if (filters?.ownershipType) queryParams.append('ownershipType', filters.ownershipType)

    const { data } = await axios.get(`${API_BASE_URL}?${queryParams.toString()}`)
    return data
}

export const getTrailerById = async (id: string): Promise<ClientTrailer> => {
    const { data } = await axios.get(`${API_BASE_URL}/${id}`)
    return data
}

export const createTrailer = async (trailerData: Partial<ClientTrailer>): Promise<ClientTrailer> => {
    const { data } = await axios.post(API_BASE_URL, trailerData)
    return data
}

export const updateTrailer = async (id: string, trailerData: Partial<ClientTrailer>): Promise<ClientTrailer> => {
    const { data } = await axios.put(`${API_BASE_URL}/${id}`, trailerData)
    return data
}

export const deleteTrailer = async (id: string): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/${id}`)
}

export const deleteMultipleTrailers = async (ids: string[]): Promise<{ deletedCount: number }> => {
    const { data } = await axios.delete(API_BASE_URL, { data: { trailerIds: ids } })
    return data
}

export const assignTruckToTrailer = async (trailerId: string, truckId: string): Promise<ClientTrailer> => {
    const { data } = await axios.post(`${API_BASE_URL}/${trailerId}/assign-truck`, { truckId })
    return data
}

export const unassignTruckFromTrailer = async (trailerId: string): Promise<ClientTrailer> => {
    const { data } = await axios.post(`${API_BASE_URL}/${trailerId}/unassign-truck`)
    return data
}

const trailerApi = {
    getTrailers,
    getTrailerById,
    createTrailer,
    updateTrailer,
    deleteTrailer,
    deleteMultipleTrailers,
    assignTruckToTrailer,
    unassignTruckFromTrailer,
}

export default trailerApi
